import React, { useEffect, useRef } from 'react';
import { serviceAreas } from '../data/mockData';

export default function LeafletMap() {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    // Wait for Leaflet to be fully loaded
    const initMap = () => {
      if (typeof window.L === 'undefined' || !mapRef.current) {
        return;
      }

      // Avoid re-creating the map if it already exists
      if (mapInstanceRef.current) {
        return;
      }

      try {
        // Centre de la zone (entre les 3 villes)
        const center = [50.45, 4.58];

        // Initialiser la carte
        const map = window.L.map(mapRef.current, {
          center: center,
          zoom: 11,
          scrollWheelZoom: true
        });

        // Ajouter les tuiles OpenStreetMap
        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 19,
        }).addTo(map);

        // Ajouter les marqueurs pour chaque commune
        serviceAreas.forEach((area) => {
          const marker = window.L.marker([area.coordinates.lat, area.coordinates.lng]).addTo(map);
          
          marker.bindPopup(`
            <div style="font-family: sans-serif; padding: 4px;">
              <strong style="color: #d97706; font-size: 14px;">${area.name}</strong><br/>
              <span style="font-size: 12px; color: #525252;">Code postal: ${area.postalCode}</span>
            </div>
          `);
        });

        // Ajouter un cercle pour la zone d'intervention (rayon de 10 km)
        window.L.circle(center, {
          radius: 10000, // 10 km en mètres
          color: '#d97706',
          fillColor: '#fbbf24',
          fillOpacity: 0.15,
          weight: 2
        }).addTo(map).bindPopup(`
          <div style="font-family: sans-serif; padding: 4px;">
            <strong style="color: #d97706;">Zone d'intervention</strong><br/>
            <span style="font-size: 12px;">Rayon de 10 km</span>
          </div>
        `);

        // Stocker l'instance de la carte
        mapInstanceRef.current = map;

        // Force map to re-render after a short delay
        setTimeout(() => {
          map.invalidateSize();
        }, 100);

      } catch (error) {
        console.error('Error initializing Leaflet map:', error);
      }
    };

    // Try to initialize immediately if Leaflet is already loaded
    if (typeof window.L !== 'undefined') {
      initMap();
    } else {
      // Otherwise wait a bit for the script to load
      const timer = setTimeout(initMap, 500);
      return () => clearTimeout(timer);
    }

    // Cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div 
      ref={mapRef} 
      id="leaflet-map"
      style={{ 
        height: '500px', 
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#f5f5f5'
      }}
    />
  );
}

